var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SpFinder',{ref:"finder",attrs:{"noSelection":"","url":_vm.URL,"setting":_vm.setting,"fixed-row-action":"","hooks":{
      beforeSearch: _vm.beforeSearch
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }